const commercialListComponent = document.querySelector('.commercial-list');
if (commercialListComponent) {
  let numToPreload = 0;
  let getCommercialData = async function() {
    const successMessage = document.querySelector('.rest-message--success').value;
    const errorMessage = document.querySelector('.rest-message--fail').value;
    const numToPreloadField = document.querySelector('.num-preload');
    if (numToPreloadField) {
      numToPreload = numToPreloadField.value;
    }

    let URL = `${APIPrefix.get()}/search_api/commercialunits/list`;
    let data = APIUtils.getComponentData(commercialListComponent, URL, successMessage, errorMessage, 'fader');

    return data;
  };

  getCommercialData()
    .then((data) => {
      let preloaded = 0;
      data.data.commercialUnitsIds.forEach((id) => {
        if (preloaded >= numToPreload) {
          const LI = document.createElement('li');
          commercialListComponent.appendChild(LI);
          let commercialDevBlock = buildCommercialDevelopmentBlock(id);
          LI.appendChild(commercialDevBlock.element);

          let observer = new IntersectionObserver(handleCommercialIntersect, commercialDevBlock.options);
          observer.observe(commercialDevBlock.element);
        } else {
          preloaded = preloaded + 1;
        }
      });
    })
    .catch((e) => console.log(e));


  let getCommercialInfo = async function(id) {
    let infoResponse = await fetch(`${APIPrefix.get()}/search_api/commercialunits/details?commercialUnitId=${id}`);
    if (!infoResponse.ok) {
      throw new Error(`HTTP error! status: ${infoResponse.status}`);
    }
    let info = await infoResponse.json();
    return info;
  };

  let lazyloadCommercialDevelopment = function(developmentDiv) {
    let devId = developmentDiv.dataset.id;

    getCommercialInfo(devId)
      .then((info) => {
        developmentDiv.innerHTML = populateCommercialDevelopmentBlock(info.data);
      })
      .catch((e) => console.log(e));

  };

  let handleCommercialIntersect = function(entries, observer) {
    for (let entry of entries) {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        lazyloadCommercialDevelopment(entry.target);
      }
    }
  };

  // Get a development block with a loading spinner and just the development ID populated
  let buildCommercialDevelopmentBlock = function(id) {
    let devDiv = document.createElement('div');
    devDiv.setAttribute('data-id', id);
    devDiv.className = 'wrapper';
    devDiv.id = id;
    devDiv.innerHTML = `
    <div class="item-wrapper">
      <div class="result-wrapper empty">
        <a href="#" class="image-wrapper">
          <img alt="" width="558" height="280" loading="lazy" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=">
        </a>
        <div class="content-wrapper">
        </div>
      </div>
    </div>`;

    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2,
    };
    return {'element': devDiv, 'options': options};
  };

  let populateCommercialDevelopmentBlock = function(itemsInfo) {
    return `
      <div class="item-wrapper">
        <div class="result-wrapper loaded">
          <a href="${itemsInfo.viewCommercialUnitsButton.url}" class="image-wrapper" title="${itemsInfo.previewImage.alt}">
            <img width="558" height="280" loading="lazy" src="${itemsInfo.previewImage.path}" alt="${itemsInfo.previewImage.alt}">
          </a>
          <div class="content-wrapper">
            <div class="content-info">
              <div class="info-wrapper">
                <h2>${itemsInfo.name}</h2>
                <span class="address">${itemsInfo.address}</span>
              </div>
            </div>
            <div class="bottom-wrapper">
              <div class="bottom-info">
                ${itemsInfo.homeIcon ?
                  `<div class="details-content">
                    <div class="icon">
                      <img src="${itemsInfo.homeIcon.path}" alt="${itemsInfo.homeIcon.alt}">
                       ${itemsInfo.commercialUnitsTypes}
                    </div>
                  </div>` : ``}
              </div>
              <p class="description">${itemsInfo.shortDescription}</p>
              <div class="cta-wrapper">
                <a href="${itemsInfo.viewCommercialUnitsButton.url}" class="button button--primary" title="${itemsInfo.viewCommercialUnitsButton.name}">${itemsInfo.viewCommercialUnitsButton.name} </a>
              </div>
            </div>
          </div>
        </div>
      </div>`;
  };
}